module.exports = __webpack_public_path__ + "static/media/kadpoly.c8d39545.jfif";